const BROWSERS = [
  ['Edge', /Edg\/(\d+)/],
  ['Opera', /OPR\/(\d+)/],
  ['Chrome', /(?:Chrome|CriOS)\/(\d+)/],
  ['Firefox', /(?:Firefox|FxiOS)\/(\d+)/],
  ['Safari', /Version\/(\d+).+Safari/],
]

const getBrowser = (userAgent) => {
  const browser = BROWSERS.find(([, pattern]) => pattern.test(userAgent))

  if (!browser) {
    return 'Unknown browser'
  }

  const [name, pattern] = browser
  const version = userAgent.match(pattern)?.[1]

  return version ? `${name} ${version}` : name
}

const getOperatingSystem = (userAgent, platform) => {
  if (/iPhone|iPad|iPod/.test(userAgent)) {
    return 'iOS'
  }

  if (/Android/.test(userAgent)) {
    return 'Android'
  }

  if (/Macintosh|Mac OS X/.test(userAgent) || platform === 'macOS') {
    return 'macOS'
  }

  if (/Windows/.test(userAgent) || platform === 'Windows') {
    return 'Windows'
  }

  if (/Linux/.test(userAgent) || platform === 'Linux') {
    return 'Linux'
  }

  return platform || 'Unknown OS'
}

export const formatClientEnvironment = ({
  userAgent,
  platform,
  screenWidth,
  screenHeight,
  pixelRatio,
}) =>
  `${getBrowser(userAgent)}, ${getOperatingSystem(userAgent, platform)}, screen ${screenWidth}x${screenHeight} @${pixelRatio}x`

export const getClientEnvironment = () =>
  formatClientEnvironment({
    userAgent: navigator.userAgent,
    platform: navigator.userAgentData?.platform || navigator.platform,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    pixelRatio: window.devicePixelRatio || 1,
  })
